import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IMyOptions, IMyDate, IMyDateModel } from 'mydatepicker-th';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from "@angular/common";
import { JobService } from 'src/app/services/job.service';
import { UtilsService } from 'src/app/services/utils.service';
import emailMask from 'text-mask-addons/dist/emailMask';
import numberlMask from 'text-mask-addons/dist/createNumberMask';
import { FormGroup, FormBuilder, Validators, FormArray, MaxLengthValidator } from "@angular/forms";
import { Location } from '@angular/common';


@Component({
  selector: 'app-job-apply',
  templateUrl: './job-apply.component.html',
  styleUrls: ['./job-apply.component.scss']
})
export class JobApplyComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))

  private sub: any
  jobid: string
  Personal: boolean
  Education: boolean
  Family: boolean
  Experience: boolean
  Another: boolean
  defaultTitle = this.language.jobchoose
  defaultTitleEN = "เลือก"
  TitleTH: any = ['นาย', 'นาง', 'นางสาว']
  TitleEN: any = ['Mr.', 'Mrs.', 'Ms.']

  expected_salary = '0'
  title_th: any
  fname_th: any
  lname_th: any
  title_en: any
  fname_en: any
  lname_en: any
  tel: any
  mobile: any
  email: any
  birthday: any
  age: any
  
  identity: any
  domicile: any = ""
  nationality: any
  religion: any
  contact_address: any = ""
  address: any = ""
  Bday: any

  //Req
  Reqexpected_salary = false
  Reqlname_th = false
  Reqfname_th = false
  Reqltitle_th = false
  Reqtitle_en = false
  Reqfname_en = false
  Reqlname_en = false
  Reqtel = false
  Reqmobile = false
  Reqemail = false
  emailinvalidPattern = false
  Reqbirthday = false
  Reqeage = false
  Reqidentity = false
  Reqnationality = false
  Reqreligion = false
  Reqdomicile = false
  Reqcontact_address = false
  Reqaddress = false
  military_status = 1

  check = false

  dateFormatted: string

  myDatePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
  }

  myDatePickerOptionsEN: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  }

  emailPattern = emailMask
  emailPatternCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


  numberPattern = numberlMask
  mub = /^[0-9]{1,7}$/

  unamePattern = "^[a-z0-9_-]{8,15}$";
  pwdPattern = "^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$";
  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  flag: any
  constructor(

    // private datePipe: DatePipe,
    private _JobApplyService: JobService,
    private router: Router, private route: ActivatedRoute,
    private location: Location,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.setjobid();
    //  var jobid = localStorage.getItem("jobid");
    this.flag = localStorage.getItem("language_flag")

    this.sub = this.route.queryParams.subscribe(params => {
      this.jobid = params['jobid'] || 0;
    });
    let jobid = localStorage.getItem('jobid');
    // this.mockupData();
  }
  transform(value: string) {
    let datePipe = new DatePipe("en-US");
    value = datePipe.transform(value, 'yyyy-MM-dd');
    if (this.flag == 'th') {
      var date = value.split('-');
      date[0] = String(Number(date[0]) + 543);
      value = date.join('-')
    }
    localStorage.setItem("birthday", value);
    return value
  }

  onDateChanged(event) {
    this.dateFormatted = this.transform(event.jsdate)
    if (!this.utils.isNullOrUndefined(event.jsdate) && !this.utils.isNullOrUndefined(event.jsdate.getFullYear())){
      const dateNow:any = new Date();
      let ageDate:any = dateNow - event.jsdate;    
      ageDate = new Date(ageDate);
      this.age = Math.abs(ageDate.getUTCFullYear() - 1970);  
    }  
    
  }
  
  goEducation() {
    
    this.Reqexpected_salary = this.utils.isNullOrUndefined(this.expected_salary)? true :false;

    if (this.title_th === undefined || this.title_th === '' || this.title_th === null) {
      this.Reqltitle_th = true;
    } else {
      this.Reqltitle_th = false;
    }

    if (this.fname_th === undefined || this.fname_th === '' || this.fname_th === null) {
      this.Reqfname_th = true;
    } else {
      this.Reqfname_th = false;
    }

    if (this.lname_th === undefined || this.lname_th === '' || this.lname_th === null) {
      this.Reqlname_th = true;
    } else {
      this.Reqlname_th = false;
    }

    if (this.title_en === undefined || this.title_en === '' || this.title_en === null) {
      this.Reqtitle_en = true;
    } else {
      this.Reqtitle_en = false;
    }

    if (this.fname_en === undefined || this.fname_en === '' || this.fname_en === null) {
      this.Reqfname_en = true;
    } else {
      this.Reqfname_en = false;
    }

    if (this.lname_en === undefined || this.lname_en === '' || this.lname_en === null) {
      this.Reqlname_en = true;
    } else {
      this.Reqlname_en = false;
    }

    if (this.mobile === undefined || this.mobile === '' || this.mobile === null) {
      this.Reqmobile = true;
    } else {
      this.Reqmobile = false;
    }

    if (this.email === undefined || this.email === '' || this.email === null) {
      this.Reqemail = true
    } else if (this.email !== undefined) {
      this.Reqemail = false
      if (this.email.match(this.emailPatternCheck) === null) {
        this.emailinvalidPattern = true
      } else {
        this.emailinvalidPattern = false
      }
    }

    if (this.birthday === undefined || this.birthday === '' || this.birthday === null) {
      this.Reqbirthday = true;
    } else {
      this.Reqbirthday = false;
    }

    if (this.age === undefined || this.age === '' || this.age === null) {
      this.Reqeage = true;
    } else {
      this.Reqeage = false;
    }

    if (this.identity === undefined || this.identity === '' || this.identity === null) {
      this.Reqidentity = true;
    } else {
      this.Reqidentity = false;
    }

    if (this.nationality === undefined || this.nationality === '' || this.nationality === null) {
      this.Reqnationality = true;
    } else {
      this.Reqnationality = false;
    }

    if (this.utils.isNullOrUndefined(this.religion) ) {
      this.religion = ''
    } 

    if (this.utils.isNullOrUndefined(this.domicile) ) {
      this.domicile = ''
    } 
    if (this.utils.isNullOrUndefined(this.tel) ) {
      this.tel = ''
    } 
    // if (this.domicile === undefined || this.domicile === '' || this.domicile === null) {
    //   this.Reqdomicile = true;
    // } else {
    //   this.Reqdomicile = false;
    // }

    if (this.contact_address === undefined || this.contact_address === '' || this.contact_address === null) {
      this.Reqcontact_address = true;
    } else {
      this.Reqcontact_address = false;
    }
    if (this.utils.isNullOrUndefined(this.address)) {
      this.Reqaddress = true;
    } else {
      this.Reqaddress = false;
    }
    if (this.emailinvalidPattern == true) {

      alert("กรุณากรอกอีเมลให้ถูกต้อง");

    } else {
      if (this.Reqltitle_th == false && this.Reqfname_th == false && this.Reqlname_th == false &&
        this.Reqtitle_en == false && this.Reqfname_en == false && this.Reqlname_en == false && this.Reqmobile == false && this.Reqemail == false &&
        this.Reqbirthday == false && this.Reqeage == false && this.Reqidentity == false &&
        this.Reqnationality == false && this.Reqdomicile == false && this.Reqcontact_address == false && !this.Reqaddress) {

        this.sub = this.route.queryParams.subscribe(params => {
          this.jobid = params['jobid'] || 0;
        });

        var birthday = localStorage.getItem("birthday");
        var yearType = (this.flag == 'th') ? '(พ.ศ.)' : '(ค.ศ.)'

        // console.log(this.jobid);
        if (this.jobid === undefined || this.jobid === '' || this.jobid === null || Number(this.jobid) === 0) {
          if (confirm(this.language.jobapplydetailerror3)) {
            this.location.back()
          }
        } else {
          this._JobApplyService.setApply_Personal(this.expected_salary, this.title_th, this.fname_th, this.lname_th, this.title_en, this.fname_en, this.lname_en, this.tel, this.mobile, this.email, birthday, this.age, this.identity, this.domicile, this.nationality, this.religion, this.contact_address, this.jobid, yearType,this.address,this.military_status).subscribe(result => {

            if (result.returncode == "1000") {
              localStorage.setItem("personid", result.personid);
              this.check = true;
            }else{
              console.log(result.desc);              
            }

            if (this.check == true) {
              this.router.navigate(['/job-apply-education']);
            } else {
              return false;
            }
          })
        }
      }
    }
  }

  onclickTitle(value) {
    this.title_th = value;
    if (this.title_th !== 'นาย') {
      this.military_status = 1;
    }
  }

  onclickTitleEN(valueEN) {
    this.title_en = valueEN;
  }

  setjobid() {

    this.sub = this.route.queryParams.subscribe(params => {
      this.jobid = params['jobid'] || 0;
    });

    // var jobid = localStorage.setItem("jobid", this.jobid);

    var x = localStorage.setItem('abc', this.jobid);
  }

  
  setMilitary_status(event) {
    this.military_status = event;

  }
}